import { useEffect } from 'react'

/**
 * Captures ?ref= param from URL into localStorage for later claiming.
 * Should be called early in the app (e.g., in LanguageLayout).
 */
export function useReferralCapture() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const ref = params.get('ref')
    if (ref && /^[A-Za-z0-9]{8}$/.test(ref)) {
      localStorage.setItem('pendingReferral', ref.toUpperCase())
    }
  }, [])
}
